
import React from 'react';
import { AppButton, Box, FiservCardInterface, Preloader, ResetIcon } from '@common-fe/common-fe';

import DisableActionHintWrapper from '@/modules/transaction/Cards/components/DisableActionHintWrapper.tsx';

import { CardStatusActionWrap } from '../ChangeStatusCardModal.styles';

import CardActionCardHeader from './CardActionCardHeader';

interface CardReplaceActionCardProps {
  card?: FiservCardInterface;
  loadingButton?: boolean;
  isMailWithin7Days: boolean;
  onOpenCardReplacementModal: () => void;
}

const CardReplaceActionCard: React.FC<CardReplaceActionCardProps> = ({
  card,
  loadingButton,
  isMailWithin7Days,
  onOpenCardReplacementModal,
}) => {
  return (
    <CardStatusActionWrap
      background="canvas"
      round="container1Round"
      border={{ color: 'border2', size: 'small' }}
    >
      <CardActionCardHeader
        icon={<ResetIcon size="xlarge" color="iconAccent" />}
        title="Replace"
        description={(
          <>
            Get a new card if there are
            <br />
            any issues.
          </>
        )}
        descriptionLineHeight="20px"
      />
      <DisableActionHintWrapper
        card={card}
        hideHint={!isMailWithin7Days}
        hintElement={(
          <AppButton
            width="100%"
            buttonType="primary"
            disabled={isMailWithin7Days || loadingButton}
            onClick={onOpenCardReplacementModal}
          >
            {loadingButton ? (
              <Box width="100%" align="center">
                <Preloader color="white" />
              </Box>
            ) : (
              'Replace'
            )}
          </AppButton>
        )}
      />
    </CardStatusActionWrap>
  );
};

export default CardReplaceActionCard;
